export const ALLOWED_TERMINAL_IDS: number[] = [1, 209, 189, 4, 109, 611, 153, 863];

export const isInboundFreightAllowed = (terminalId?: number): boolean => {
  return terminalId != null && ALLOWED_TERMINAL_IDS.includes(terminalId);
};
